/* global window */
/* global grecaptcha */
import React from "react"
import Layout from "../components/layout"
import { Link } from "gatsby"
import Input from "../components/input"
import Helmet from "react-helmet"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import PropTypes from "prop-types"
import TextField from "@material-ui/core/TextField"
import { withStyles } from "@material-ui/core/styles"
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined"
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined"
import PhoneIphoneOutlinedIcon from "@material-ui/icons/PhoneIphoneOutlined"

import { CONSENTS } from "../components/gaprovider"

import style from "../components/contact.module.scss"
import SchemaComponent from "../components/schema-component"

const SUBMISSION_SUBMIT = "sub-sub"
const SUBMISSION_SUCCESS = "sub-suc"
const SUBMISSION_FAILED = "sub-err"

const CAPTCHA_NOTLOADED = undefined
const CAPTCHA_LOADING = "cap-load"
const CAPTCHA_LOADED = "cap-ldd"

const CustomTextField = withStyles({
  root: {
    "& div": {
      padding: 0,
      display: "block",
    },
    "& div::after": {
      borderBottom: "none !important",
    },
    "& div::before": {
      borderBottom: "none !important",
    },
    "& div:hover::before": {
      borderBottom: "none !important",
    },
  },
  disabled: {},
})(props => <TextField disableRipple={true} {...props} />)

export default class ContactPage extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      submission: undefined,
      captcha: undefined,
    }

    this.contactRef = React.createRef()

    this.setStateIfMounted = () => {}

    this.doFetch = token => {
      this.setState({ submission: SUBMISSION_SUBMIT })
      const postLocation = `${window.location.protocol}//${window.location.host}/contactus/`
      fetch(postLocation, {
        method: "POST",
        mode: "same-origin",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...this.state.submissionData, token }, null, 0),
      })
        .then(res => {
          // console.log("finished fetch")
          // console.log(res)
          if (res && res.ok) {
            this.setStateIfMounted({ submission: SUBMISSION_SUCCESS })
          } else {
            this.setStateIfMounted({ submission: SUBMISSION_FAILED })
          }
        })
        .catch(_ => {
          this.setStateIfMounted({ submission: SUBMISSION_FAILED })
        })
    }
  }

  componentDidMount() {
    if (window.loadedCaptcha) {
      this.setState({ captch: CAPTCHA_LOADED })
    } else if (window.loadingCaptcha) {
      this.setState({ captcha: CAPTCHA_LOADING })
    }

    this.setStateIfMounted = this.setState

    let gcToken = undefined

    this.resetCaptcha = () => {
      if (window.grecaptcha != null) {
        if (this.widgetId) {
          grecaptcha.reset(this.widgetId)
        } else {
          grecaptcha.reset()
        }
        gcToken = undefined
      }
    }

    this.executeCaptcha = () => {
      if (gcToken) {
        this.doFetch(gcToken)
        return
      }
      grecaptcha.execute()
    }

    window.captchaLoadCallback = () => {
      this.setStateIfMounted({ captcha: CAPTCHA_LOADED })
      window.loadedCaptcha = true
    }

    window.onCaptchaExpire = () => {
      gcToken = undefined
    }

    window.onCaptchaSuccess = token => {
      gcToken = token
      this.doFetch(token)
    }

    if (this.state.captcha === CAPTCHA_LOADING && window.loadedCaptcha) {
      this.setState({ captcha: CAPTCHA_LOADED })
    } else if (
      this.context.consents[CONSENTS.FUNCTIONAL] &&
      this.state.captcha === CAPTCHA_NOTLOADED
    ) {
      this.initializeCaptcha()
    }

    if (this.state.captcha === CAPTCHA_LOADED || window.loadedCaptcha) {
      this.widgetId = grecaptcha.render("recaptcha")
    }

    const userPart = "contact"
    const domainPart = "obicis.com"
    const atPart = "@"
    const schemaPart = "mailto:"
    this.contactRef.current.innerHTML = `<a href="${schemaPart +
      userPart +
      atPart +
      domainPart}">${userPart}<code>${atPart}</code>${domainPart}</a>`
    // this.contactRef.current.innerHTML = `Send us an email to <a href="${schemaPart +
    //   userPart +
    //   atPart +
    //   domainPart}">${userPart}<code>${atPart}</code>${domainPart}</a> or use the form below.`
  }

  componentWillUnmount() {
    this.setStateIfMounted = () => {}
    window.captchaLoadCallback = function() {}
    window.onCaptchaExpire = function() {}
    window.onCaptchaSuccess = function() {}
    this.resetCaptcha()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.state.captcha === CAPTCHA_NOTLOADED &&
      this.context.consents[CONSENTS.FUNCTIONAL]
    ) {
      this.initializeCaptcha()
    }
    if (
      this.state.submission === SUBMISSION_FAILED &&
      prevState.submission !== SUBMISSION_FAILED
    ) {
      this.resetCaptcha()
    }
  }

  initializeCaptcha() {
    const script = document.createElement("script")
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=captchaLoadCallback&hl=en"
    script.async = true
    this.setState({ captcha: CAPTCHA_LOADING })
    window.loadingCaptcha = true
    document.body.appendChild(script)
  }

  render() {
    let content
    const shouldDisableInputs =
      this.state.submission === SUBMISSION_SUBMIT ||
      this.state.submission === SUBMISSION_SUCCESS
    if (!this.context.consents[CONSENTS.FUNCTIONAL]) {
      content = (
        <div>
          The contact form requires the use of the functional group of cookies.
          Please visit our <Link to="/privacy-legal/">privacy policy</Link> for
          details about the purpose of this group and our cookie use in general.
          <br />
          <br />
          <span>
            {!this.context.consents[CONSENTS.ANALYTICS_BASIC] ? (
              <div
                className={["agree-container", style.agreeContainer].join(" ")}
              >
                <a
                  href="#"
                  role="button"
                  onClick={() => {
                    const newConsent = {}
                    newConsent[CONSENTS.FUNCTIONAL] = true
                    newConsent[CONSENTS.ANALYTICS_BASIC] = true
                    this.context.setConsents(newConsent)
                  }}
                  className={["agree-button"].join(" ")}
                >
                  I consent to all cookies
                </a>
              </div>
            ) : (
              ""
            )}
            <div
              className={["agree-container", style.agreeContainer].join(" ")}
            >
              <a
                href="#"
                role="button"
                onClick={() => {
                  const newConsent = {}
                  newConsent[CONSENTS.FUNCTIONAL] = true
                  this.context.setConsents(newConsent)
                }}
                className={["agree-button"].join(" ")}
              >
                I consent to functional cookies
              </a>
            </div>
          </span>
        </div>
      )
    } else {
      content = (
        <Formik
          validationSchema={contactSchema}
          validateOnChange={false}
          onSubmit={async values => {
            this.setState({
              submissionData: { ...values },
            })
            this.executeCaptcha()
          }}
          initialValues={{
            name: "",
            email: "",
            phone: "",
            message: "",
          }}
        >
          {props => (
            <Form className={["contact-form", style.form].join(" ")} noValidate>
              <Input
                type="name"
                name="name"
                placeholder="Name*"
                disabled={shouldDisableInputs}
              />
              <Input
                type="email"
                name="email"
                placeholder="Email*"
                disabled={shouldDisableInputs}
              />
              <Input
                type="phone"
                name="phone"
                placeholder="Contact number"
                disabled={shouldDisableInputs}
              />
              <Input
                type="message"
                name="message"
                placeholder="Message*"
                doValidate={() => props.validateField("message")}
              >
                {({ field, form, meta, cbRef }) => {
                  const inputProps = {}
                  if (shouldDisableInputs) {
                    inputProps.readOnly = true
                  }
                  return (
                    <CustomTextField
                      id="message"
                      label=""
                      multiline
                      onInput={e =>
                        form.setFieldValue(field.name, e.target.value)
                      }
                      inputRef={cbRef}
                      onBlur={() => {
                        props.setFieldTouched("message")
                      }}
                      inputProps={inputProps}
                      // onBlur={() => props.validateField("message")}
                      // rowsMax="4"
                      // value={value}
                      // onChange={handleChange}
                    />
                    // <div
                    //   id="message"
                    //   className={[style.messageInput].join(" ")}
                    //   contentEditable={!shouldDisableInputs}
                    //   {...field}
                    //   ref={cbRef}
                    //   onInput={e => {e.persist(); console.log(e);
                    //     e.target
                    //     form.setFieldValue(field.name, e.target.innerText)
                    //   }}
                    // >
                    // <br />
                    // </div>
                  )
                }}
              </Input>
              {/* <Input
                type="message"
                name="message"
                placeholder="Message*"
                doValidate={() => props.validateField("message")}
              >
                {({ field, form, meta, cbRef }) => (
                  <div
                    id="message"
                    className={[style.messageInput].join(" ")}
                    contentEditable={!shouldDisableInputs}
                    {...field}
                    ref={cbRef}
                    onInput={e => {e.persist(); console.log(e);
                      e.target
                      form.setFieldValue(field.name, e.target.innerText)
                    }}
                  >
                    <br />
                  </div>
                )}
              </Input> */}
              <br />
              <br />
              By sending the message you agree to our{" "}
              <a
                href="../privacy-legal/"
                rel="noreferrer noopener"
                target="_blank"
              >
                personal data &amp; privacy policy
              </a>
              .
              <div
                className={["submit-container", style.submitContainer].join(
                  " "
                )}
              >
                {this.state.captcha !== CAPTCHA_LOADED ? (
                  <span className={["submit-button", style.submit].join(" ")}>
                    Loading...
                  </span>
                ) : this.state.submission === SUBMISSION_SUBMIT ? (
                  <span className={["submit-button", style.submit].join(" ")}>
                    Sending...
                  </span>
                ) : this.state.submission === SUBMISSION_SUCCESS ? (
                  <span className={["submit-button", style.submit].join(" ")}>
                    Sent
                  </span>
                ) : this.state.submission === SUBMISSION_FAILED ? (
                  <a
                    href="#"
                    role="button"
                    onClick={props.handleSubmit}
                    className={["submit-button", style.submit].join(" ")}
                  >
                    Failed. Click to retry.
                  </a>
                ) : (
                  <a
                    href="#"
                    role="button"
                    onClick={props.handleSubmit}
                    className={["submit-button", style.submit].join(" ")}
                  >
                    Send
                  </a>
                )}
              </div>
            </Form>
          )}
        </Formik>
      )
    }
    return (
      <Layout>
        <Helmet>
          <title>Contact Us - Obicis</title>
          <meta
            name="description"
            content="Obicis is a Croatian company engaged in software development across the globe. 
            Send us a message and let our success story become a part of yours!"
          />
          <meta property="og:title" content="Contact Us" />
          <meta property="og:url" content="https://www.obicis.com/contact/" />
          <meta
            property="og:description"
            content="Obicis is a Croatian company engaged in software development across the globe. 
            Send us a message and let our success story become a part of yours!"
          />
        </Helmet>
        <SchemaComponent
          description="Obicis is a Croatian company engaged in software development across the globe. Contact us to have our experts and experienced developers assist you."
          breadcrumb={{
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Contact Us",
                item: "https://www.obicis.com/contact/",
              },
            ],
          }}
        />
        <div className={["content"].join(" ")}>
          <b>
            {this.context.time}
            Whether you need ex&shy;pe&shy;ri&shy;enced
            de&shy;vel&shy;op&shy;ers to build your project or experts to
            com&shy;ple&shy;ment your team's ca&shy;pa&shy;bil&shy;i&shy;ties,
            contact us!
            <br />
            <br />
            <div className={[style.contactContainer].join(" ")}>
              <BusinessOutlinedIcon className={[style.contactIcon].join(" ")} />
              <span className={[style.contactText].join(" ")}>
                Trakošćanska 6<br />
                HR-10 090 Zagreb
                <br />
                Croatia
              </span>
            </div>
            <br />
            <div className={[style.contactContainer].join(" ")}>
              <EmailOutlinedIcon className={[style.contactIcon].join(" ")} />
              <span
                ref={this.contactRef}
                className={[style.contactText].join(" ")}
              ></span>
            </div>
            <br />
            <div className={[style.contactContainer].join(" ")}>
              <PhoneIphoneOutlinedIcon
                className={[style.contactIcon].join(" ")}
              />
              <span className={[style.contactText].join(" ")}>
                <a href="tel:+ 385 (98) 1838 131">+ 385 (98) 1838 131</a>
              </span>
            </div>
          </b>
          <br />
          <br />
          {content}
        </div>
        <div className={["recaptcha-container", style.rcpContainer].join(" ")}>
          <div
            id="recaptcha"
            className="g-recaptcha"
            data-sitekey="6LdRFOcUAAAAAGMePk0CN6EZnqCf5gqwAfknWaFk"
            data-callback="onCaptchaSuccess"
            data-badge="inline"
            data-error-callback="onCaptchaFail"
            data-expired-callback="onCaptchaExpire"
            data-size="invisible"
          ></div>
        </div>
      </Layout>
    )
  }
}

ContactPage.contextTypes = {
  setConsents: PropTypes.func,
  consents: PropTypes.object,
}

const contactSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  phone: Yup.string(),
  message: Yup.string()
    .min(5, "Required")
    .max(2048, "Too Long!")
    .required("Required"),
  email: Yup.string()
    .email("Please check your email address")
    .required("Required"),
})
